import { Kbd } from './Primitives';

const GROUPS: { title: string; rows: [string[], string][] }[] = [
  {
    title: 'Move',
    rows: [
      [['←', '→'], 'Previous / next photo'],
      [['Space'], 'Next photo'],
      [['Home', 'End'], 'First / last photo'],
    ],
  },
  {
    title: 'Decide',
    rows: [
      [['1'], 'Keep'],
      [['2'], 'Reject'],
      [['0'], 'Clear the decision'],
      [['Z'], 'Undo'],
      [['⇧', 'Z'], 'Redo'],
    ],
  },
  {
    title: 'Adjust',
    rows: [
      [['⌘', '←'], 'Rotate left'],
      [['⌘', '→'], 'Rotate right'],
      [['A'], 'Toggle auto-advance'],
    ],
  },
  {
    title: 'Review Assist',
    rows: [
      [['↵'], 'Open the burst under the cursor'],
      [['Esc'], 'Close it again'],
      [['S'], 'Sort sharpest first'],
    ],
  },
  {
    title: 'Other',
    rows: [
      [['F'], 'Cycle filter'],
      [['?'], 'This list'],
      [['Esc'], 'Back to the shoot'],
    ],
  },
];

export default function ShortcutSheet({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink-950/80 p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
    >
      <div
        className="card w-full max-w-lg animate-rise p-6"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-baseline justify-between">
          <h2 className="text-head font-medium">Keyboard</h2>
          <button className="btn-ghost" onClick={onClose}>
            Close <Kbd>Esc</Kbd>
          </button>
        </div>

        <div className="mt-5 grid gap-6 sm:grid-cols-2">
          {GROUPS.map((group) => (
            <section key={group.title}>
              <h3 className="label">{group.title}</h3>
              <dl className="mt-2.5 flex flex-col gap-1.5">
                {group.rows.map(([keys, description]) => (
                  <div key={description} className="flex items-center justify-between gap-3">
                    <dt className="text-caption text-ink-300">{description}</dt>
                    <dd className="flex shrink-0 gap-1">
                      {keys.map((key) => (
                        <Kbd key={key}>{key}</Kbd>
                      ))}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
